import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { ActionCreators } from "../../_actions/ActionCreators";
import GeografiaService from "../../services/GeografiaService";
import LojaService from "../../services/LojaService";
import Input from "../FlexFreteInput/Input";
import Modal from "../FlexFreteModal/Modal";
import { FormContainerStyle, MoreLojaStyle } from "./style";

function LojaFormEdit(props) {
  const lojaService = new LojaService();
  const geografiaService = new GeografiaService();
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  let location = useLocation();
  const loja = location.state?.res || null;
  const isCreateMode = !loja;
  let lojaPadrao = lojaService.getLojaPadrao();
  const history = useHistory();
  const [, setProcessando] = useState(false);
  const [estados, setEstados] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [semNumero, setSemNumero] = useState(loja?.endereco?.numero === "S/N" || false);
  const numero = useRef();
  const [pacote, setPacote] = useState(
    loja?.configuracoesPacoteLoja
      ? [...loja.configuracoesPacoteLoja]
      : [{ altura: null, largura: null, comprimento: null, peso: null, pacotePadrao: false }]
  );
  const [request, setRequest] = useState({
    nome: loja?.nome || "",
    razaoSocial: loja?.razaoSocial || "",
    telefone: loja?.telefone || "",
    email: loja?.email || "",
    site: loja?.site || "",
    cnpj: loja?.cnpj || "",
    padraoAssinante: loja?.isLojaPadraoAssinante || false,
    logradouro: loja?.endereco?.logradouro || "",
    numero: loja?.endereco?.numero || "",
    cep: loja?.endereco?.cep || "",
    bairro: loja?.endereco?.bairro || "",
    cidade: loja?.endereco?.cidade || "",
    estado: loja?.endereco?.estado || "",
    complemento: loja?.endereco?.complemento || "",
    referencia: loja?.endereco?.referencia || "",
  });

  const [erro, setErro] = useState({
    isWrong: false,
    titulo: "",
    mensagem: "",
    voltar: false,
  });
  useEffect(() => {
    geografiaService.obtemEstados((erro, sucesso) => {
      if (erro) {
        setErro({
          isWrong: true,
          mensagem:
            "Falha ao obter estados, entre em contato com o suporte ou tente novamente mais tarde",
        });
        return;
      }
      if (sucesso) {
        setEstados(sucesso);
        if (request.estado) {
          getCidades(request.estado);
        }
      }
    });
    return () => {
      setRequest({});
      setCidades([]);
      setEstados([]);
      setPacote([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCidades = (event) => {
    let city;

    if (event.target) {
      const { value } = event.target;
      city = value;
      setRequest((prev) => ({ ...prev, estado: value, cidade: "" }));
    } else {
      city = event;
    }
    if (!city) return;
    geografiaService.obtemMunicipios(city, (erro, sucesso) => {
      if (erro) {
        setErro({
          isWrong: true,
          mensagem:
            "Falha ao obter municipios, entre em contato com o suporte ou tente novamente mais tarde",
        });
        return;
      }
      if (sucesso) {
        setCidades(sucesso);
      }
    });
  };

  const getCEP = (cep) => {
    geografiaService.buscaPorCEP(cep, (erro, sucesso) => {
      if (erro) {
        setErro({
          isWrong: true,
          mensagem:
            "Falha ao buscar por CEP, entre em contato com o suporte ou insira seu endereço manualmente",
        });
        return;
      }
      if (sucesso) {
        setRequest((prevState) => ({
          ...prevState,
          logradouro: sucesso.logradouro,
          bairro: sucesso.bairro,
          cidade: sucesso.cidade,
          estado: sucesso.siglaUf,
          cep: sucesso.cep,
        }));
        getCidades(sucesso.siglaUf);
      }
    });
  };

  const removePacote = (i) => {
    const list = [...pacote];
    list.splice(i, 1);
    setPacote(list);
  };

  const osPacotes = pacote.map((item, i) => {
    return (
      <div key={item.uuid || i} className={i > 0 ? "pacote-item mt-4" : "pacote-item"}>
        {i > 0 ? <hr /> : null}
        <div className="is-flex columns">
          <div className="field column">
            <label className="label">Altura</label>
            <div className="field has-addons">
              <div className="control is-expanded">
                <Input
                  type="number"
                  name="altura"
                  defaultValue={item.altura}
                  placeholder="2"
                  onChange={(event) => onChangePacote(event, i)}
                />
              </div>
              <div className="control">
                <span className="button is-static">cm</span>
              </div>
            </div>
          </div>

          <div className="field column">
            <label className="label">Largura</label>
            <div className="field has-addons">
              <div className="control is-expanded">
                <Input
                  type="number"
                  name="largura"
                  defaultValue={item.largura}
                  placeholder="12"
                  onChange={(event) => onChangePacote(event, i)}
                />
              </div>
              <div className="control">
                <span className="button is-static">cm</span>
              </div>
            </div>
          </div>

          <div className="field column">
            <label className="label">Comprimento</label>
            <div className="field has-addons">
              <div className="control is-expanded">
                <Input
                  type="number"
                  name="comprimento"
                  defaultValue={item.comprimento}
                  placeholder="17"
                  onChange={(event) => onChangePacote(event, i)}
                />
              </div>
              <div className="control">
                <span className="button is-static">cm</span>
              </div>
            </div>
          </div>

          <div className="field column">
            <label className="label">Peso (kg)</label>
            <div className="field has-addons">
              <div className="control is-expanded">
                <Input
                  type="number"
                  name="peso"
                  defaultValue={item.peso}
                  placeholder="1"
                  onChange={(event) => onChangePacote(event, i)}
                />
              </div>
              <div className="control">
                <span className="button is-static">kg</span>
              </div>
            </div>
          </div>
        </div>

        <div className="column mb-4">
          <div className="control">
            <label className="checkbox ffl-custom-checkbox">
              <input
                type="checkbox"
                name="pacotePadrao"
                defaultChecked={item.pacotePadrao}
                onChange={(event) => onChangePacote(event, i)}
              />
              &nbsp;<strong>Definir como pacote padrão desta loja</strong>
            </label>
          </div>
        </div>

        {pacote.length > 1 ? (
          <div className="control-checkbox">
            <span className="add-more-pacotes" onClick={() => removePacote(i)}>
              <ion-icon name="trash-outline"></ion-icon> Remover
            </span>
          </div>
        ) : null}
      </div>
    );
  });

  const addMorePacotes = () => {
    setPacote([
      ...pacote,
      {
        altura: null,
        largura: null,
        comprimento: null,
        peso: null,
        pacotePadrao: false,
      },
    ]);
  };

  const onChange = (event) => {
    const { name, value, type, checked } = event.target;

    if (event._reactName === "onFocus" && event.target.name === "cnpj") {
      event.target.setCustomValidity("Preencha este campo.");
      return;
    } else {
      event.target.setCustomValidity("");
    }

    if (event._reactName === "onFocus" && event.target.name === "telefone") {
      event.target.setCustomValidity("Preencha este campo.");
      return;
    } else {
      event.target.setCustomValidity("");
    }

    if (loja && lojaPadrao && lojaPadrao.uuid === loja.uuid && checked === false) {
      localStorage.removeItem("lojaPadrao");
    }
    let req = request;
    type === "checkbox" ? (req[name] = checked) : (req[name] = value);
    setRequest({ ...req });
  };

  const onChangeSemNumero = (event) => {
    setSemNumero(event.target.checked);
    if (event.target.checked) {
      numero.current.value = "S/N";
    } else {
      numero.current.value = request.numero;
    }
  };

  const onChangePacote = (event, i) => {
    const { name, value, type, checked } = event.target;

    let list = [...pacote];
    type === "checkbox" ? (list[i][name] = checked) : (list[i][name] = value);

    let gettingAllCheckedAsTrue = [];
    for (let lst of list) {
      if (lst.pacotePadrao === true) {
        gettingAllCheckedAsTrue.push(lst.pacotePadrao);
      }
    }
    if (gettingAllCheckedAsTrue.length > 1) {
      setErro({
        isWrong: true,
        mensagem: "Só pode haver um pacote padrão",
      });
      return;
    }
    setPacote(list);
  };

  const onChangeEndereco = (event) => {
    const { name, value } = event.target;

    if (event._reactName === "onFocus" && event.target.name === "cep") {
      event.target.setCustomValidity("Preencha este campo.");
    } else {
      event.target.setCustomValidity("");
    }

    let req = request;
    req[name] = value;
    setRequest({ ...req });

    if (name === "cep") {
      const formatedcep = value.replace(/[^0-9]/g, "");
      if (formatedcep.length === 8) {
        getCEP(formatedcep);
      }
    }
  };

  const onBlur = (event) => {
    let cep = event.target.value;
    if (!cep.length) {
      return;
    }
    let formatedcep = cep.replace(/[^0-9]/g, "");
    return getCEP(formatedcep);
  };

  const submitForm = (event) => {
    event.preventDefault();

    setProcessando(true);

    if (request.cep.length < 8) {
      setErro({
        isWrong: true,
        mensagem: "CEP inválido.",
      });
      setProcessando(false);
      return;
    }

    const cnpjNumerico = (request.cnpj || "").replace(/[^0-9]/g, "");
    if (cnpjNumerico.length !== 14) {
      setErro({
        isWrong: true,
        mensagem: "CNPJ inválido.",
      });
      setProcessando(false);
      return;
    }

    /**let formatedTel = request.telefone.replace(/[^0-9]/g, "");
    const resultTel = validarTelefone(formatedTel);
    if (!resultTel) {
      setErro({
        isWrong: true,
        mensagem: "Telefone inválido.",
      });
      setProcessando(false);
      return;
    }

    const resultEmail = validarEmail(request.email);
    if (!resultEmail) {
      setErro({
        isWrong: true,
        mensagem: "E-mail inválido.",
      });
      setProcessando(false);
      return;
    }*/

    const endereco = {
      logradouro: request.logradouro,
      numero: semNumero === true ? "S/N" : request.numero,
      cep: request.cep,
      bairro: request.bairro,
      cidade: request.cidade,
      estado: request.estado,
      complemento: request.complemento,
      referencia: request.referencia,
    };

    if (isCreateMode) {
      const lojaRequest = {
        nome: request.razaoSocial,
        razaoSocial: request.razaoSocial,
        telefone: request.telefone,
        email: request.email,
        site: request.site,
        cnpj: cnpjNumerico,
        ativo: true,
        padraoAssinante: request.padraoAssinante || false,
        endereco,
        configuracoesPacoteLoja: [...pacote],
      };
      lojaService.criarNovaLoja(lojaRequest, (erro, sucesso) => {
        if (erro) {
          setProcessando(false);
          setErro({
            isWrong: true,
            mensagem:
              erro.response?.data?.message ||
              "Falha ao criar loja, entre em contato com o suporte ou tente novamente mais tarde",
          });
          return;
        }
        if (sucesso) {
          setProcessando(false);
          dispatch(ActionCreators.showModal(true));
          history.push("/configuracoes/minha-loja");
        }
      });
    } else {
      const lojaRequest = {
        nome: request.razaoSocial,
        razaoSocial: request.razaoSocial,
        telefone: request.telefone,
        email: request.email,
        site: request.site,
        cnpj: cnpjNumerico,
        ativo: loja.ativo !== undefined ? loja.ativo : true,
        padraoAssinante: request.padraoAssinante,
        assinatura: {
          uuid: loja.assinatura.uuid,
          usuarioAssinante: {
            uuid: user.uuid,
            nome: user.nome,
            roles: user.roles,
            cpf: user.username,
          },
        },
        endereco,
        configuracoesPacoteLoja: [...pacote],
      };
      lojaService.editarLoja(loja.uuid, lojaRequest, (erro, sucesso) => {
        if (erro) {
          setProcessando(false);
          setErro({
            isWrong: true,
            mensagem:
              erro.response?.data?.message ||
              "Falha ao editar loja, entre em contato com o suporte ou tente novamente mais tarde",
          });
          return;
        }
        if (sucesso) {
          setProcessando(false);
          dispatch(ActionCreators.showModal(true));
          history.push("/configuracoes/minha-loja");
        }
      });
    }
  };

  const voltaParaMinhasLojasPage = () => {
    dispatch(ActionCreators.showModal(false));
    history.push("/configuracoes/minha-loja");
  };

  const callbackModal = () => {
    if (erro.isWrong === true) {
      setErro({ isWrong: false });
    }
  };

  return (
    <>
      {erro.isWrong === true ? (
        <Modal
          callbackModal={callbackModal}
          visivel={erro !== null}
          titulo={erro.titulo}
          conteudo={erro.mensagem}
        />
      ) : null}
      <MoreLojaStyle>
        <h1>{isCreateMode ? "Nova Loja" : "Editar Loja"}</h1>
        <FormContainerStyle>
          <form onSubmit={submitForm}>
            <div className="box">
              <h2>Dados da Loja</h2>
              {/* Campo oculto para simplificar o formulário de criação (lógica em JS mantida intacta) */}
              {/* <Input
                type="text"
                name="nome"
                label="Nome*"
                defaultValue={request.nome}
                required={true}
                onChange={onChange}
              /> */}
              <div className="is-flex columns">
                <div className="field column">
                  <div className="control">
                    <Input
                      maxLength={255}
                      type="text"
                      name="razaoSocial"
                      placeholder="Nome"
                      defaultValue={request.razaoSocial}
                      required={true}
                      onChange={onChange}
                    />
                  </div>
                </div>

                <div className="field column">
                  <div className="control">
                    <Input
                      type="text"
                      mascara="99.999.999/9999-99"
                      disabled={!isCreateMode}
                      defaultValue={request.cnpj}
                      name="cnpj"
                      placeholder="CNPJ*"
                      maxLength="18"
                      required={true}
                      onChange={onChange}
                    />
                  </div>
                </div>
              </div>

              {/* Campos ocultos para simplificar o formulário de criação (lógica em JS mantida intacta) */}
              {/* <Input
                type="tel"
                mascara={{ telefoneMask }}
                name="telefone"
                label="Telefone*"
                defaultValue={request.telefone}
                required={true}
                onChange={onChange}
                onFocus={onFocusTelefone}
                onBlur={onBlurTelefone}
              />
              <Input
                type="email"
                name="email"
                label="E-mail*"
                defaultValue={request.email}
                required={true}
                onChange={onChange}
              />
              <Input
                type="text"
                name="site"
                label="Site*"
                defaultValue={request.site}
                required={true}
                onChange={onChange}
              /> */}

              <div className="is-flex columns">
                <div className="field column">
                  <div className="control">
                    <Input
                      type="text"
                      mascara="99999-999"
                      name="cep"
                      placeholder="CEP*"
                      defaultValue={request.cep}
                      required={true}
                      onChange={onChangeEndereco}
                      onBlur={onBlur}
                    />
                  </div>
                </div>

                <div className="field column">
                  <div className="control">
                    <Input
                      maxLength={255}
                      className="input"
                      type="text"
                      name="logradouro"
                      placeholder="Endereço"
                      required={true}
                      onChange={onChange}
                      value={request.logradouro}
                    />
                  </div>
                </div>
              </div>
              <div className="is-flex columns">
                <div className="field column">
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      name="numero"
                      ref={numero}
                      defaultValue={request.numero}
                      placeholder="número"
                      disabled={semNumero ? true : false}
                      required={semNumero ? false : true}
                      onChange={onChange}
                    />
                  </div>
                  <div className="control mt-2">
                    <label className="checkbox ffl-custom-checkbox">
                      <input
                        type="checkbox"
                        name="aceito"
                        onChange={onChangeSemNumero}
                        defaultChecked={semNumero}
                      />
                      &nbsp;<strong>Sem número</strong>
                    </label>
                  </div>
                </div>

                <div className="field column">
                  <div className="control">
                    <Input
                      type="text"
                      name="complemento"
                      defaultValue={request.complemento}
                      placeholder="Complemento"
                      onChange={onChange}
                    />
                  </div>
                </div>
              </div>

              {/* Campo oculto para simplificar o formulário de criação (lógica em JS mantida intacta) */}
              {/* <Input
                type="text"
                name="referencia"
                label="Referência"
                defaultValue={request.referencia}
                onChange={onChange}
              /> */}

              <div className="is-flex columns">
                <div className="field column is-half">
                  <div className="field">
                    <div className="control">
                      <Input
                        type="text"
                        name="bairro"
                        placeholder="Bairro"
                        value={request.bairro}
                        required={true}
                        onChange={onChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="field column">
                  <div className="control">
                    <div className="select">
                      <select
                        value={request.cidade}
                        name="cidade"
                        placeholder="Cidade"
                        style={{ width: "100%" }}
                        required={true}
                        onChange={onChangeEndereco}
                      >
                        <option value=""></option>
                        {cidades.map((cidade, index) => {
                          return (
                            <option key={cidade.nome + index} value={cidade.uuid}>
                              {cidade.nome}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="field column">
                  <div className="control">
                    <div className="select">
                      <select
                        value={request.estado}
                        name="estado"
                        placeholder="Estado"
                        style={{ width: "100%" }}
                        required={true}
                        onChange={getCidades}
                      >
                        <option value=""></option>
                        {estados.map((estado, index) => {
                          return (
                            <option key={estado.nome + index} value={estado.nome}>
                              {estado.nomeExtenso} - {estado.nome}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="column mb-4">
                <div className="control">
                  <label className="checkbox ffl-custom-checkbox">
                    <input
                      type="checkbox"
                      name="padraoAssinante"
                      defaultChecked={request.padraoAssinante}
                      disabled={loja && lojaPadrao && lojaPadrao.uuid !== loja.uuid ? true : false}
                      onChange={onChange}
                    />
                    &nbsp; <strong>Definir como loja padrão</strong>
                  </label>
                  {loja && lojaPadrao && lojaPadrao.uuid !== loja.uuid ? (
                    <small className="help">
                      Você já tem uma loja marcada como padrão. Para mudar, altere o status dela
                      antes de selecionar esta como padrão.
                    </small>
                  ) : null}
                </div>
              </div>

              <hr />
              <h2>Tamanho padrão de pacote</h2>
              {osPacotes}
              <div className="control-checkbox">
                <span className="add-more-pacotes" onClick={addMorePacotes}>
                  <ion-icon name="add-outline"></ion-icon> Adicionar outros
                </span>
              </div>

              <div className="btn-loja-nova">
                <p onClick={voltaParaMinhasLojasPage} className="button">
                  Cancelar
                </p>
                <button className="button">Salvar</button>
              </div>
            </div>
          </form>
        </FormContainerStyle>
      </MoreLojaStyle>
    </>
  );
}

export default LojaFormEdit;
